import React, { useEffect, useState, useMemo } from "react";
import "./Table.css";
import CountUp from "react-countup";
import ColumnSearch from "./ColumnSearch";
import { Button, ConfigProvider, Segmented, Tooltip } from 'antd';

function DistrictTable({
  data,
  setMapStatistic,
  setRegionHighlighted,
  setClientTableExpand,
  clientData
}) {
  const [sorting, setSorting] = useState({
    column: "potential_clients",
    order: "desc",
  });

  const [search,setSearch]=useState(null)
  const [searchColumn,setSearchColumn]=useState(null)

  const tableData = useMemo(() => {
    if (sorting?.column == "state") {
      if (sorting?.order == "asc") {
        return data?.sort((a, b) => {
          return a["district"]?.localeCompare(b["district"]);
        });
      } else {
        return data?.sort((a, b) => {
          return b["district"]?.localeCompare(a["district"]);
        });
      }
    } else {
      if (sorting?.order == "asc") {
        return data?.sort((a, b) => {
          return a[sorting?.column] - b[sorting?.column];
        });
      } else {
        return data?.sort((a, b) => {
          return b[sorting?.column] - a[sorting?.column];
        });
      }
    }
  }, [data, sorting?.column, sorting?.order]);

  return (
    <div className="table district">
      <div className="table-head">
        <div
          style={{ cursor: "pointer" }}
          onClick={() => {
            if (sorting?.column === "state" && sorting?.order === "asc") {
              setSorting({
                column: "state",
                order: "desc",
              });
            } else {
              setSorting({
                column: "state",
                order: "asc",
              });
            }

            // if(sorting?.column==='state'&&!sorting?.order){
            //   setSorting({
            //     column:'state',
            //     order:'asc'
            //   })
            // }else if(!sorting?.column&&!sorting?.order){
            //     setSorting({
            //       column:'state',
            //       order:'asc'
            //     })
            // }
            // else if(sorting?.column!=='state'&&sorting?.order){
            //     setSorting({
            //       column:'state',
            //       order:'asc'
            //     })
            //   }
            //   else if(sorting?.column==='state'&&sorting?.order==='asc'){
            //     setSorting({
            //       column:'state',
            //       order:'desc'
            //     })
            //   }else if(sorting?.column==='state'&&sorting?.order==='desc'){
            //     setSorting({
            //       column:'state',
            //       order:'asc'
            //     })
            //   }
          }}
        >
          <div>District</div>
          <div style={{display:'flex',justifyContent:'space-between'}}>
            {sorting?.column === "state" && (
              <>
                {sorting?.order === "asc" ? (
                  <svg
                    aria-hidden="true"
                    focusable="false"
                    role="img"
                    class="octicon octicon-sort-asc"
                    viewBox="0 0 16 16"
                    width="12"
                    height="12"
                    fill="currentColor"
                  >
                    <path d="m12.927 2.573 3 3A.25.25 0 0 1 15.75 6H13.5v6.75a.75.75 0 0 1-1.5 0V6H9.75a.25.25 0 0 1-.177-.427l3-3a.25.25 0 0 1 .354 0ZM0 12.25a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5H.75a.75.75 0 0 1-.75-.75Zm0-4a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 8.25Zm0-4a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 4.25Z"></path>
                  </svg>
                ) : (
                  <svg
                    aria-hidden="true"
                    focusable="false"
                    role="img"
                    class="octicon octicon-sort-desc"
                    viewBox="0 0 16 16"
                    width="12"
                    height="12"
                    fill="currentColor"
                  >
                    <path d="M0 4.25a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 4.25Zm0 4a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 8.25Zm0 4a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5H.75a.75.75 0 0 1-.75-.75ZM13.5 10h2.25a.25.25 0 0 1 .177.427l-3 3a.25.25 0 0 1-.354 0l-3-3A.25.25 0 0 1 9.75 10H12V3.75a.75.75 0 0 1 1.5 0V10Z"></path>
                  </svg>
                )}
              </>
            )}


          <ColumnSearch className={'disrict-seacrh'} setSearch={setSearch} setSearchColumn={setSearchColumn} column={'district'} />
          </div>
        </div>
        <div
          style={{ cursor: "pointer" }}
          onClick={() => {
            if (
              sorting?.column === "potential_clients" &&
              sorting?.order === "asc"
            ) {
              setSorting({
                column: "potential_clients",
                order: "desc",
              });
            } else {
              setSorting({
                column: "potential_clients",
                order: "asc",
              });
            }
          }}
        >
          <div>Propsect</div>
          <div>
            {sorting?.column === "potential_clients" && (
              <>
                {sorting?.order === "asc" ? (
                  <svg
                    aria-hidden="true"
                    focusable="false"
                    role="img"
                    class="octicon octicon-sort-asc"
                    viewBox="0 0 16 16"
                    width="12"
                    height="12"
                    fill="currentColor"
                  >
                    <path d="m12.927 2.573 3 3A.25.25 0 0 1 15.75 6H13.5v6.75a.75.75 0 0 1-1.5 0V6H9.75a.25.25 0 0 1-.177-.427l3-3a.25.25 0 0 1 .354 0ZM0 12.25a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5H.75a.75.75 0 0 1-.75-.75Zm0-4a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 8.25Zm0-4a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 4.25Z"></path>
                  </svg>
                ) : (
                  <svg
                    aria-hidden="true"
                    focusable="false"
                    role="img"
                    class="octicon octicon-sort-desc"
                    viewBox="0 0 16 16"
                    width="12"
                    height="12"
                    fill="currentColor"
                  >
                    <path d="M0 4.25a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 4.25Zm0 4a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 8.25Zm0 4a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5H.75a.75.75 0 0 1-.75-.75ZM13.5 10h2.25a.25.25 0 0 1 .177.427l-3 3a.25.25 0 0 1-.354 0l-3-3A.25.25 0 0 1 9.75 10H12V3.75a.75.75 0 0 1 1.5 0V10Z"></path>
                  </svg>
                )}
              </>
            )}
          </div>
        </div>
        <div
          style={{ cursor: "pointer" }}
          onClick={() => {
            if (
              sorting?.column === "onboarded_clients" &&
              sorting?.order === "asc"
            ) {
              setSorting({
                column: "onboarded_clients",
                order: "desc",
              });
            } else {
              setSorting({
                column: "onboarded_clients",
                order: "asc",
              });
            }
          }}
        >
          <div>Onboard</div>
          <div>
            {sorting?.column === "onboarded_clients" && (
              <>
                {sorting?.order === "asc" ? (
                  <svg
                    aria-hidden="true"
                    focusable="false"
                    role="img"
                    class="octicon octicon-sort-asc"
                    viewBox="0 0 16 16"
                    width="12"
                    height="12"
                    fill="currentColor"
                  >
                    <path d="m12.927 2.573 3 3A.25.25 0 0 1 15.75 6H13.5v6.75a.75.75 0 0 1-1.5 0V6H9.75a.25.25 0 0 1-.177-.427l3-3a.25.25 0 0 1 .354 0ZM0 12.25a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5H.75a.75.75 0 0 1-.75-.75Zm0-4a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 8.25Zm0-4a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 4.25Z"></path>
                  </svg>
                ) : (
                  <svg
                    aria-hidden="true"
                    focusable="false"
                    role="img"
                    class="octicon octicon-sort-desc"
                    viewBox="0 0 16 16"
                    width="12"
                    height="12"
                    fill="currentColor"
                  >
                    <path d="M0 4.25a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 4.25Zm0 4a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 8.25Zm0 4a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5H.75a.75.75 0 0 1-.75-.75ZM13.5 10h2.25a.25.25 0 0 1 .177.427l-3 3a.25.25 0 0 1-.354 0l-3-3A.25.25 0 0 1 9.75 10H12V3.75a.75.75 0 0 1 1.5 0V10Z"></path>
                  </svg>
                )}
              </>
            )}
          </div>
        </div>
        <div
          style={{ cursor: "pointer" }}
          onClick={() => {
            if (sorting?.column === "ACTIVE" && sorting?.order === "asc") {
              setSorting({
                column: "ACTIVE",
                order: "desc",
              });
            } else {
              setSorting({
                column: "ACTIVE",
                order: "asc",
              });
            }
          }}
        >
          <div>Active</div>
          <div>
            {sorting?.column === "ACTIVE" && (
              <>
                {sorting?.order === "asc" ? (
                  <svg
                    aria-hidden="true"
                    focusable="false"
                    role="img"
                    class="octicon octicon-sort-asc"
                    viewBox="0 0 16 16"
                    width="12"
                    height="12"
                    fill="currentColor"
                  >
                    <path d="m12.927 2.573 3 3A.25.25 0 0 1 15.75 6H13.5v6.75a.75.75 0 0 1-1.5 0V6H9.75a.25.25 0 0 1-.177-.427l3-3a.25.25 0 0 1 .354 0ZM0 12.25a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5H.75a.75.75 0 0 1-.75-.75Zm0-4a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 8.25Zm0-4a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 4.25Z"></path>
                  </svg>
                ) : (
                  <svg
                    aria-hidden="true"
                    focusable="false"
                    role="img"
                    class="octicon octicon-sort-desc"
                    viewBox="0 0 16 16"
                    width="12"
                    height="12"
                    fill="currentColor"
                  >
                    <path d="M0 4.25a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 4.25Zm0 4a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 8.25Zm0 4a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5H.75a.75.75 0 0 1-.75-.75ZM13.5 10h2.25a.25.25 0 0 1 .177.427l-3 3a.25.25 0 0 1-.354 0l-3-3A.25.25 0 0 1 9.75 10H12V3.75a.75.75 0 0 1 1.5 0V10Z"></path>
                  </svg>
                )}
              </>
            )}
          </div>
        </div>
        <div
          style={{ cursor: "pointer" }}
          onClick={() => {
            if (sorting?.column === "INACTIVE" && sorting?.order === "asc") {
              setSorting({
                column: "INACTIVE",
                order: "desc",
              });
            } else {
              setSorting({
                column: "INACTIVE",
                order: "asc",
              });
            }
          }}
        >
          <div>InActive</div>
          <div>
            {sorting?.column === "INACTIVE" && (
              <>
                {sorting?.order === "asc" ? (
                  <svg
                    aria-hidden="true"
                    focusable="false"
                    role="img"
                    class="octicon octicon-sort-asc"
                    viewBox="0 0 16 16"
                    width="12"
                    height="12"
                    fill="currentColor"
                  >
                    <path d="m12.927 2.573 3 3A.25.25 0 0 1 15.75 6H13.5v6.75a.75.75 0 0 1-1.5 0V6H9.75a.25.25 0 0 1-.177-.427l3-3a.25.25 0 0 1 .354 0ZM0 12.25a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5H.75a.75.75 0 0 1-.75-.75Zm0-4a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 8.25Zm0-4a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 4.25Z"></path>
                  </svg>
                ) : (
                  <svg
                    aria-hidden="true"
                    focusable="false"
                    role="img"
                    class="octicon octicon-sort-desc"
                    viewBox="0 0 16 16"
                    width="12"
                    height="12"
                    fill="currentColor"
                  >
                    <path d="M0 4.25a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 4.25Zm0 4a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 8.25Zm0 4a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5H.75a.75.75 0 0 1-.75-.75ZM13.5 10h2.25a.25.25 0 0 1 .177.427l-3 3a.25.25 0 0 1-.354 0l-3-3A.25.25 0 0 1 9.75 10H12V3.75a.75.75 0 0 1 1.5 0V10Z"></path>
                  </svg>
                )}
              </>
            )}
          </div>
        </div>
      </div>

      <div className="table-body">
        {tableData?.filter(data=>{
                if(search===null||search===''){
                    return data
                }else{
                    if(data[searchColumn]?.toString()?.toLowerCase()?.includes(search?.toString()?.toLowerCase())){
                        return data
                    }
                }
            })?.map((data, id) => (
          <div key={id}>
            <div style={{ cursor: "poniter" }}>
              <div>{data["district"]}</div>
              <div
                onMouseEnter={() => {
                  setMapStatistic("clients");
                  setRegionHighlighted({
                    stateCode: data?.stateCode,
                    value: data?.potential_clients,
                    districtName: data["district"],
                  });
                }}

                onClick={()=>{
                  setClientTableExpand({
                    state:data?.stateCode,
                    district: data["district"],
                    stage:'prospects'
                  })
                }}
              >
                <CountUp
                  start={0}
                  end={data?.potential_clients}
                  duration={0.5}
                  delay={0}
                />
              </div>
              <Tooltip style={{height:'200px',overflowY:'scroll'}} placement="left" title={clientData?.filter(data1=>{
                    if((data1['master.status']==='ACTIVE' ||data1['master.status']==='INACTIVE') && data1['master.district']===data?.district){
                        return data
                    }
                })
                    ?.map((data)=>( <div>
                     {data?.['master.client_name']}
                </div>))} >
              <div
                onMouseEnter={() => {
                  setRegionHighlighted({
                    stateCode: data?.stateCode,
                    value: data?.onboarded_clients,
                    districtName: data["district"],
                  });
                  setMapStatistic("onboard");
                }}
                onClick={()=>{
                  setClientTableExpand({
                    state:data?.stateCode,
                    district: data["district"],
                    stage:'onboard'
                  })
                }}
              >
                <CountUp
                  start={0}
                  end={data?.onboarded_clients}
                  duration={0.5}
                  delay={0}
                />
              </div>
              </Tooltip>
              <div
                onMouseEnter={() => {
                  setMapStatistic("active");
                  setRegionHighlighted({
                    stateCode: data?.stateCode,
                    value: data?.ACTIVE,
                    districtName: data["district"],
                  });
                }}
                onClick={()=>{
                  setClientTableExpand({
                    state:data?.stateCode,
                    district: data["district"],
                    stage:'active'
                  })
                }}
              >
                <CountUp
                  start={0}
                  end={data?.ACTIVE}
                  duration={0.5}
                  delay={0}
                />
              </div>
              <div
                onMouseEnter={() => {
                  setMapStatistic("inactive");
                  setRegionHighlighted({
                    stateCode: data?.stateCode,
                    value: data?.INACTIVE,
                    districtName: data["district"],
                  });
                }}
                onClick={()=>{
                  setClientTableExpand({
                    state:data?.stateCode,
                    district: data["district"],
                    stage:'inactive'
                  })
                }}
              >
                <CountUp
                  start={0}
                  end={data?.INACTIVE}
                  duration={0.5}
                  delay={0}
                />
              </div>
            </div>

            {/* {isDistrictView && <Ta} */}
          </div>
        ))}
      </div>
    </div>
  );
}

export default DistrictTable;
